import * as React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { authenticationService } from '../../services/authentication';
import { PageRoutes } from './Routes';

class PublicRoute extends React.Component<any, any> {
    render() {
        let render = (props: any) => {
            let Component: any = this.props.component;
            return (
                <Component {...props} {...this.props} />
            );
        };
        if (authenticationService.getWasAuthenticated()) {
            return <Redirect to={PageRoutes.Dashboard} />;
        } else {
            return (
                <Route exact={this.props.exact} render={render} />
            );
        }
    }
}

export default PublicRoute;



// WEBPACK FOOTER //
// ./src/webportal/components/root/PublicRoute.tsx